import { render } from "./ArtistStats.vue?vue&type=template&id=866b1db6"
import script from "./ArtistStats.vue?vue&type=script&lang=js"
export * from "./ArtistStats.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ArtistStats.vue?vue&type=style&index=0&id=866b1db6&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__